import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import mainBannerBgDark from '../assets/png/mainbanner-dots_bg-dark.png';

const ConnectWalletBlock: React.FC = () => {
  const { theme } = useTheme();
  
  return (
    <div className="bg-white dark:bg-[rgba(21,23,36,0.7)] h-auto md:h-[298px] overflow-hidden relative rounded-xl w-full backdrop-blur-sm border border-contrast-7 dark:border-transparent">
      {/* Background image for dark theme */}
      {theme === 'dark' && (
        <div 
          className="absolute inset-0 bg-no-repeat opacity-30"
          style={{ 
            backgroundImage: `url(${mainBannerBgDark})`,
            backgroundPosition: 'top right',
            backgroundSize: 'auto'
          }}
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-azul/10 via-transparent to-primary-azul/5" />
      
      {/* Content container */}
      <div className="relative md:absolute md:left-1/2 md:top-16 md:transform md:-translate-x-1/2 flex flex-col items-center gap-8 md:gap-12 w-full max-w-[891px] px-4 py-12 md:px-0 md:py-0">
        {/* Text container */}
        <div className="flex flex-col items-center gap-4 text-center w-full">
          <h2 className="text-contrast-3 dark:text-white text-[20px] md:text-[24px] font-medium font-geist">Connect your wallet</h2>
          <p className="text-contrast-5 dark:text-contrast-6 text-[16px] font-inter max-w-[891px] px-4 md:px-0">
            Connect your wallet and switch to the Base network to check your eligibility and claim your $VLR tokens.
          </p>
        </div>
        
        {/* RainbowKit Connect Button with custom styling */}
        <ConnectButton.Custom>
          {({
            account,
            chain,
            openAccountModal,
            openChainModal,
            openConnectModal,
            mounted,
          }) => {
            const ready = mounted;
            const connected = ready && account && chain;

            return (
              <div
                {...(!ready && {
                  'aria-hidden': true,
                  'style': {
                    opacity: 0,
                    pointerEvents: 'none',
                    userSelect: 'none',
                  },
                })}
              >
                {(() => {
                  if (!connected) {
                    return (
                      <button 
                        onClick={openConnectModal} 
                        className="h-10 md:h-12 w-[280px] md:w-[304px] rounded-lg bg-primary-papaya hover:bg-opacity-90 transition-all shadow-[0_2px_12px_0_rgba(255,158,0,0.20),0_0_14px_0_rgba(255,158,0,0.60)_inset,0_0_16px_0_rgba(90,63,229,0.15)]"
                      >
                        <span className="text-white text-base md:text-lg font-medium font-inter">Connect Wallet</span>
                      </button>
                    );
                  }

                  if (chain.unsupported) {
                    return (
                      <button 
                        onClick={openChainModal} 
                        className="h-12 w-[304px] rounded-lg bg-red-500 hover:bg-opacity-90 transition-all shadow-lg"
                      >
                        <span className="text-white text-lg font-medium font-inter">Wrong network</span>
                      </button>
                    );
                  }

                  return (
                    <div className="flex gap-3">
                      <button
                        onClick={openChainModal}
                        className="flex items-center gap-2 h-12 px-4 rounded-lg bg-white dark:bg-contrast-2 border border-contrast-6 dark:border-contrast-5 hover:bg-contrast-7 dark:hover:bg-contrast-3 transition-colors"
                      >
                        {chain.hasIcon && (
                          <div className="w-5 h-5">
                            {chain.iconUrl && (
                              <img
                                alt={chain.name ?? 'Chain icon'}
                                src={chain.iconUrl}
                                className="w-5 h-5"
                              />
                            )}
                          </div>
                        )}
                        <span className="text-contrast-3 dark:text-contrast-8 text-sm font-medium font-inter">{chain.name}</span>
                      </button>

                      <button 
                        onClick={openAccountModal}
                        className="h-12 px-6 rounded-lg bg-primary-papaya hover:bg-opacity-90 transition-all shadow-lg"
                      >
                        <span className="text-white text-lg font-medium font-inter">
                          {account.displayName}
                          {account.displayBalance
                            ? ` (${account.displayBalance})`
                            : ''}
                        </span>
                      </button>
                    </div>
                  );
                })()}
              </div>
            );
          }}
        </ConnectButton.Custom>
      </div>
    </div>
  );
};

export default ConnectWalletBlock;